export enum GearServiceStatus {
    None = 0,
    Good = 1,
    Watch = 2,
    Bad = 3,
    Retired = 4
} 